var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "lg",
        "confirm-loading": _vm.loading,
        "confirm-text": "Lưu",
        "cancel-text": "Đóng",
        "use-panel": true,
        "panel-title": "Nhận xét ngày",
        "panel-subtitle": "Tạo hoặc chỉnh sửa nhận xét cho học sinh theo ngày",
        "panel-icon": "el-icon-edit-outline",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleSave,
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-u-mt-12",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "left",
            "label-width": "140px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sk-form-grid" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Học sinh", prop: "studentId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "Chọn học sinh",
                        filterable: "",
                        disabled: "",
                      },
                      on: { change: _vm.handleStudentChange },
                      model: {
                        value: _vm.dataForm.studentId,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "studentId", $$v)
                        },
                        expression: "dataForm.studentId",
                      },
                    },
                    _vm._l(_vm.studentList, function (item) {
                      return _c("el-option", {
                        key: item.studentId,
                        attrs: {
                          label: item.studentName,
                          value: item.studentId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Ngày", prop: "date" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      format: "dd/MM/yyyy",
                      placeholder: "Chọn ngày",
                      disabled: "",
                    },
                    model: {
                      value: _vm.dataForm.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "date", $$v)
                      },
                      expression: "dataForm.date",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "evl-items-section" },
            [
              _vm._l(_vm.dataForm.items, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "evl-item-card" },
                  [
                    _c(
                      "div",
                      { staticClass: "evl-item-card__header" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "220px" },
                            attrs: {
                              placeholder: "Chọn danh mục",
                              disabled: _vm.isEditMode && item._isExisting,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleItemCategoryChange(index)
                              },
                            },
                            model: {
                              value: item.categoryId,
                              callback: function ($$v) {
                                _vm.$set(item, "categoryId", $$v)
                              },
                              expression: "item.categoryId",
                            },
                          },
                          _vm._l(
                            _vm.getAvailableCategories(index),
                            function (cat) {
                              return _c("el-option", {
                                key: String(cat.id),
                                attrs: {
                                  label: cat.name,
                                  value: String(cat.id),
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    item._templates && item._templates.length > 0
                      ? _c("div", { staticClass: "evl-item-templates" }, [
                          _c(
                            "div",
                            { staticClass: "template-picker" },
                            _vm._l(item._templates, function (tpl) {
                              return _c(
                                "div",
                                {
                                  key: tpl.id,
                                  staticClass: "template-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectTemplateForItem(
                                        index,
                                        tpl
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-document" }),
                                  _c("span", [_vm._v(_vm._s(tpl.content))]),
                                ]
                              )
                            }),
                            0
                          ),
                        ])
                      : item._templateLoading
                      ? _c("div", { staticClass: "evl-item-templates" }, [
                          _c("span", { staticClass: "template-loading-hint" }, [
                            _c("i", { staticClass: "el-icon-loading" }),
                            _vm._v(" Đang tải mẫu..."),
                          ]),
                        ])
                      : _vm._e(),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder:
                          "Nhập nội dung nhận xét hoặc chọn mẫu ở trên...",
                        maxlength: "2000",
                        "show-word-limit": "",
                      },
                      model: {
                        value: item.content,
                        callback: function ($$v) {
                          _vm.$set(item, "content", $$v)
                        },
                        expression: "item.content",
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm.availableCategoriesForAdd.length > 0
                ? _c(
                    "el-button",
                    {
                      staticClass: "evl-add-item-btn",
                      attrs: {
                        type: "primary",
                        plain: "",
                        icon: "el-icon-plus",
                        size: "small",
                      },
                      on: { click: _vm.addItem },
                    },
                    [_vm._v("\n        Thêm danh mục\n      ")]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "evl-upload-section" },
            [
              _c("div", { staticClass: "evl-upload-section__header" }, [
                _c("span", { staticClass: "evl-upload-title" }, [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _vm._v(" File & hình ảnh đính kèm\n        "),
                ]),
                _c("span", { staticClass: "evl-upload-subtitle" }, [
                  _vm._v("Tối đa 3 file/nhận xét (Ảnh, Word, Excel hoặc PDF)"),
                ]),
              ]),
              _c(
                "el-upload",
                {
                  staticClass: "evl-drag-uploader",
                  attrs: {
                    drag: "",
                    action: "#",
                    "auto-upload": false,
                    "file-list": _vm.fileList,
                    limit: 3,
                    accept: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
                    multiple: "",
                    "on-change": _vm.handleFileChange,
                    "on-remove": _vm.handleFileRemove,
                    "on-exceed": _vm.handleFileExceed,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("\n          Kéo thả file/ảnh vào đây hoặc "),
                    _c("em", [_vm._v("nhấn để chọn file")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }